import { TimeUtils } from '@fibo-app/fibo-collab-shared'

const Config = {

  'date':{
    'key': 'date',
    'label': 'Date',
    'columnWidth': 50,
    'default': true,
    'order': 0,
    toData: function (info){
      return null;
    }
  },
  
  'time':{
    'key': 'time',
    'label': 'Time',
    'columnWidth': 100,
    'default': true,
    'order': 1,
    toData: function(info) {
      if (!info || !info.timeIn) {
        return ''
      }
      let result = info.timeIn + ' - '
      if (info.timeOut) {
        return result + info.timeOut
      }
      return result
    },
    toCSVFormat: function(data){
      return data
    }
  },

  'lunch': {
    'key': 'lunch',
    'label': 'Lunch',
    'columnWidth': 100,
    'default': true,
    'order': 2,
    toData: (dayClocking) => {
      if (!dayClocking || !dayClocking.timeLunchIn) {
        return ''
      }
      let result = dayClocking.timeLunchIn + ' - '
      if (dayClocking.timeLunchOut) {
        return result + dayClocking.timeLunchOut
      }
      return result
    },
    toCSVFormat: function(data) {
      return data
    }
  },

  'loggedHours': {
    'key': 'loggedHours',
    'label': 'Logged Work Hours',
    'columnWidth': 100,
    'default': true,
    'order': 3,
    // Returns the time in minutes logged as worked
    toData: (dayClocking) => TimeUtils.getIntervalTimeFromClocking(dayClocking),
    toCSVFormat: function(data){
      if (data){
        return `${(data / 60).toFixed(2)} hrs`
      }
      else return '0 hrs'
    }
  },

  'billableHours': {
    'key': 'billableHours',
    'label': 'Billable Hours',
    'columnWidth': 100,
    'default': true,
    'order': 4,
    toData: (dayClocking, billable) => {
      return billable
    },
    toCSVFormat: data => {
      return data
    }
  },

  'bwRatio': {
    'key': 'bwRatio',
    'label': 'Billable/Work Ratio',
    'columnWidth': 100,
    'default': true,
    'order': 5,
    // Returns the ratio between billable and worked
    toData: (dayClocking, billable) => {
      const worked = TimeUtils.getIntervalTimeFromClocking(dayClocking)
      if (worked) {
        return 100 * billable / worked
      }
      return NaN
    },
    toCSVFormat: data => {
      return data
    }
  },

  'notes': {
    key: 'notes',
    label: 'Day notes',
    columnWidth: 200,
    default: true,
    order: 6,
    toData: (dayClocking, billable, notes) => {
      return notes && notes.value
    },
    toCSVFormat: data => {
      return data
    }
  },

  'signature': {
    key: 'signature',
    label: 'Signature',
    columnWidth: 100,
    default: true,
    order: 7,
    toData: (dayClocking, billable, notes, signature) => {
      return signature && signature.submitted
    },
    toCSVFormat: () => {
      return null
    }
  }

}

export default Config



// WEBPACK FOOTER //
// ./src/reports/payroll/PayrollConfig.js